module.exports = __webpack_public_path__ + "static/media/inventory-3.438fe9e7.JPG";